module.exports = __webpack_public_path__ + "static/media/other1.66c42944.jpg";